import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function NoteIcon({ className, width = 17, height = 17 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-400', className)}
            width={width}
            height={height}
            viewBox='0 0 17 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M5.66663 4.07275C5.37621 4.07275 5.13538 3.83192 5.13538 3.5415V1.4165C5.13538 1.12609 5.37621 0.885254 5.66663 0.885254C5.95704 0.885254 6.19788 1.12609 6.19788 1.4165V3.5415C6.19788 3.83192 5.95704 4.07275 5.66663 4.07275Z'
                fill='currentColor'
            />
            <path
                d='M11.3334 4.07275C11.043 4.07275 10.8021 3.83192 10.8021 3.5415V1.4165C10.8021 1.12609 11.043 0.885254 11.3334 0.885254C11.6238 0.885254 11.8646 1.12609 11.8646 1.4165V3.5415C11.8646 3.83192 11.6238 4.07275 11.3334 4.07275Z'
                fill='currentColor'
            />
            <path
                d='M11.3333 16.1144H5.66667C3.08125 16.1144 1.59375 14.6269 1.59375 12.0415V6.02067C1.59375 3.43525 3.08125 1.94775 5.66667 1.94775H11.3333C13.9187 1.94775 15.4062 3.43525 15.4062 6.02067V12.0415C15.4062 14.6269 13.9187 16.1144 11.3333 16.1144ZM5.66667 3.01025C3.64083 3.01025 2.65625 3.99484 2.65625 6.02067V12.0415C2.65625 14.0673 3.64083 15.0519 5.66667 15.0519H11.3333C13.3592 15.0519 14.3437 14.0673 14.3437 12.0415V6.02067C14.3437 3.99484 13.3592 3.01025 11.3333 3.01025H5.66667Z'
                fill='currentColor'
            />
            <path
                d='M11.3333 8.32275H5.66663C5.37621 8.32275 5.13538 8.08192 5.13538 7.7915C5.13538 7.50109 5.37621 7.26025 5.66663 7.26025H11.3333C11.6237 7.26025 11.8645 7.50109 11.8645 7.7915C11.8645 8.08192 11.6237 8.32275 11.3333 8.32275Z'
                fill='currentColor'
            />
            <path
                d='M8.49996 11.8647H5.66663C5.37621 11.8647 5.13538 11.6239 5.13538 11.3335C5.13538 11.0431 5.37621 10.8022 5.66663 10.8022H8.49996C8.79038 10.8022 9.03121 11.0431 9.03121 11.3335C9.03121 11.6239 8.79038 11.8647 8.49996 11.8647Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default NoteIcon;

